import { WorkSuggestionDashboardWidgetStore } from './work-suggestion-dashboard-widget.store';
import { fb, translate } from '../../../../../shared/shared.global-service';
import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { WorkTypeEnum } from '@libs/types/src/common/enum/work-type.enum';
import {
    dateFromColumn,
    folderPersonColumn,
    serviceField,
} from '../../../../../shared/components/kit/table/table.fields';
import { getSuggestionsFrag } from './work-suggestion-dashboard-widget.query';
import { UserWidgetSetting } from '@libs/types/src/services/types/service-settings-user-widgets.type';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';
import { WorkGridItemObject } from '@it2go/types';
import { WorkDataSuggestionObject } from '@libs/types/src/services/object-type/work/work-data-suggestion.object';
import { WorkDataSuggestionTypeEnum } from '@libs/types/src/services/enum/work-data-suggestion-type.enum';
import {
    suggestionUri,
} from '../../../../../../components/social-service/work/pages/work-suggestions-page/work-suggestions-list/work-suggestions-list.component';
import { Router } from '@angular/router';
import {
    WorkDataSuggestionEvaluationStateEnum,
} from '@libs/types/src/services/enum/work-data-suggestion-evaluation-state.enum';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { ButtonComponent } from '../../../../../../components/kit/button/button.component';
import { FormatDaysDiffPipe } from '../../../../../shared/pipes/format-days-diff.pipe';
import { SuggestionDaysLeftPipe } from '../../../../../shared/pipes/suggestion-days-left.pipe';
import { LocalDatePipe } from '../../../../../shared/pipes/local-date.pipe';

@Component({
    selector: 'app-work-suggestion-dashboard-widget',
    templateUrl: './work-suggestion-dashboard-widget.component.html',
    styleUrl: './work-suggestion-dashboard-widget.component.scss',
    providers: [WorkSuggestionDashboardWidgetStore],
    imports: [
        TableComponent,
        PrimeTemplate,
        ButtonComponent,
        FormatDaysDiffPipe,
        SuggestionDaysLeftPipe,
        LocalDatePipe,
    ],
})
export class WorkSuggestionDashboardWidgetComponent {
    protected readonly router = inject(Router);
    public readonly store = inject(WorkSuggestionDashboardWidgetStore);

    items = input<{ serviceId: string, widget: UserWidgetSetting }[]>([]);

    protected columns = computed(() => {
        const showServiceInfo = [...new Set(this.items().map(x => x.serviceId))].length > 1;

        let cols = [
            folderPersonColumn,
            dateFromColumn,
            {
                name: 'type',
                dataKey: 'workData.type',
                data: (item: any) => item ? translate.instant(`workData.suggestion.enum.type.${item}`) : null,
            },
        ];

        if (showServiceInfo) {
            cols = [
                ...cols.slice(0, 1),
                serviceField('service', 'serviceId'),
                ...cols.slice(1),
            ];
        }

        return cols;
    });

    protected additionalFilters = computed<any>(() => {
        const filter = new FilterBuilder();
        filter
            .serviceIds(this.items().map(x => x.serviceId))
            .workType(WorkTypeEnum.SUGGESTION)
            .where('workData.swdsg.state', WorkDataSuggestionEvaluationStateEnum.inProgress)
        ;

        return filter.filter()?.filter || [];
    });

    protected async detail(item: WorkGridItemObject<WorkDataSuggestionObject>): Promise<void> {
        await this.router.navigateByUrl(suggestionUri(item.workData?.type as WorkDataSuggestionTypeEnum, item.id));
    }

    protected readonly getSuggestionsFrag = getSuggestionsFrag;
}
